<template>
  <div class="content">
    <div class="row text-center p-5 pr-5 d-flex align-items-center flex-wrap">
      <div class="col-sm-9 text-center">
        <div class="container-fluid p-2">
          <h1 class="display-3 d-print-inline-block">Hello</h1>
          <h1 class="display-4 d-print-inline-block">
            My name is
            <span class="font-weight-bolder text-primary fw-bold">Altheo</span>
          </h1>
        </div>
      </div>
      <div class="col-sm-3 p-1 profile-img">
        <img src="../../assets/test-avatar.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hero-content",
};
</script>
<style scoped>
img {
  width: 18rem;
}
.profile-img {
  display: ruby;
}
</style>
